import {FEATURE_NAMES, GOLOS_NARODA_STASUSES} from '../growthbook/constants';

export const enableScroll = () => {
  const scrollY = document.body.style.top;

  document.body.style.position = '';
  document.body.style.top = '';

  if (!scrollY) {
    return;
  }

  window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
};

export const disableScroll = () => {
  document.body.style.top = `-${window.scrollY}px`;
  document.body.style.position = 'fixed';
};

export const findVotes = (initialUserVotes, nominationId, type) => initialUserVotes.find(({nomination, count}) =>
  nomination === nominationId && count === type
)?.candidate || null;

export const titleMessage = (positiveName, negativeName) => {
  switch (true) {
    case !!positiveName && !!negativeName:
      return `«за» ${positiveName} и «против» ${negativeName}`;
    case !!positiveName:
      return `«за» ${positiveName}`;
    case !!negativeName:
      return `«против» ${negativeName} `;
    default:
      return 'Голосуйте «за» и «против»!';
  }
};

export const golosNarodaStatus = window.growthBook?.getFeatureValue(FEATURE_NAMES.GOLOS_NARODA_VOTING_STATUS)
    || GOLOS_NARODA_STASUSES.IN_DEVELOPMENT;

export const isGolosNarodaInDevelopment = golosNarodaStatus === GOLOS_NARODA_STASUSES.IN_DEVELOPMENT;

export const isGolosNarodaActive = golosNarodaStatus === GOLOS_NARODA_STASUSES.ACTIVE;

export const isGolosNarodaActiveWithoutWidget = golosNarodaStatus === GOLOS_NARODA_STASUSES.ACTIVE_WITHOUT_WIDGET;

export const isGolosNarodaFinished = golosNarodaStatus === GOLOS_NARODA_STASUSES.FINISHED;
